import { Shimmer } from '@components';

import { Container } from './ListEquipmentsTag.styles';

const ListEquipmentsTagLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

export { ListEquipmentsTagLoading };
